
import { request, success, failure, getApiErrorMessage } from '../../helpers';
import { tenantLogsTypes } from '../types';
import { tenantLogService } from '../../services/tenantlogs.service';

const getTenantLogs = (filterParams) => {
    return dispatch => {
        dispatch(request(tenantLogsTypes.GET_TENANT_LOGS_REQUEST));

        tenantLogService.getTenantLogs(filterParams)
            .then(
                data => {
                    if (data && data.hasOwnProperty('message')) {
                        const message = getApiErrorMessage(data);
                        dispatch(failure(tenantLogsTypes.GET_TENANT_LOGS_FAILURE, message));
                        return;
                    }

                    dispatch(success(tenantLogsTypes.GET_TENANT_LOGS_SUCCESS, { payload: data }));
                },
                (errorPayload) => {
                    const message = getApiErrorMessage(errorPayload);
                    dispatch(failure(tenantLogsTypes.GET_TENANT_LOGS_FAILURE, message));
                }
            );
    };
}

export const tenantLogsActions = {
    getTenantLogs
};
